import { suppliersApi } from "./suppliersApi";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { Supplier, CreateSupplier, UpdateSupplier } from "./suppliers.interface";
import { RootState } from "@/app/store";
import { APIError, APIResponse } from "@/types/custom-http";

export const fetchSuppliers = createAsyncThunk<
  APIResponse<Supplier[]>,
  void,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'suppliers/fetchSuppliers',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        suppliersApi.endpoints.getSuppliers.initiate()
      ).unwrap();
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
        return rejectWithValue({
          status,
          message: data?.message || 'Error al obtener proveedores',
          details: data.details
        });
    }
  }
);


export const fetchSupplierById = createAsyncThunk<APIResponse<Supplier>, number,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'suppliers/fetchSupplierById',
  async (id: number, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        suppliersApi.endpoints.getSupplierById.initiate(id)
      ).unwrap();
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al obtener Proveedor por ID',
        details: data.details
      });
    }
  }
);


export const createSupplier = createAsyncThunk<APIResponse<Supplier>, CreateSupplier,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'suppliers/createSupplier',
  async (data: CreateSupplier, { dispatch, rejectWithValue }) => {
    try {
      // Disparamos la mutación y esperamos el resultado
      const result = await dispatch(
        suppliersApi.endpoints.createSupplier.initiate(data)
      ).unwrap();
      
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al crear Proveedor',
        details: data.details
      });
    }
  }
);


export const updateSupplier = createAsyncThunk<
  APIResponse<Supplier>,
   { id: number; changes: UpdateSupplier }, 
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'suppliers/updateSupplier',
  async ({ id, changes  }, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        suppliersApi.endpoints.updateSupplier.initiate({ id, changes  })
      ).unwrap();

      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al actualizar Proveedor',
        details: data.details
      });
    }
  }
);